<template>
  <div class="info">
      <div style="font-weight:700;">设置头像</div>
    <el-divider class="divider"></el-divider>
    <div>
        <el-form >
            <el-form-item>
           <!-- 影像信息 -->
          <div class="in_2">
            <div class="in-hea" style="color:#a2a1a1;">选择一张个人正面照作为头像，成员可以更容易认识你</div>
            <el-upload
              class="avatar-uploader"
              style="padding: 25px"
              action="/api/Uploadimg"
              :data="{'token':token}"
               name="pic"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
            >
              <i v-if="imageUrl == '' || imageUrl == undefined" class="el-icon-user" style="font-size:50px"></i>
              <el-avatar v-else :size="100"  :src="imageUrl.substr(0,4) == 'http' ? imageUrl : $url.img + imageUrl"></el-avatar>
            <!-- <img v-if="imageUrl" :src="$url.img + imageUrl" class="avatar"> -->
              <div><el-button size="small" type="primary" class="btn-submit">点击上传</el-button></div>
          </el-upload>
          </div>
        <div style="font-size:1px;color:#a2a1a1;"><span style="color:red">*</span> 仅支持JPG,GIF,PNG格式上传</div>
      </el-form-item>
      <el-divider></el-divider>
      <div class="in-hea" style="font-weight: 700">个人资料</div>
      <div style="margin-top:30px" class="in">
        <el-form-item label="姓名:">
          <el-input  v-model="tableData.name"></el-input>
        </el-form-item><br>
        <el-form-item label="手机号码:">
          <el-input v-model="tableData.username"></el-input>
          <div style="font-size:1px;color:#a2a1a1;"><span style="color:red">*</span> 更改手机号后登录名也会变化</div>
        </el-form-item>
        <el-form-item label="">
          <span style="font-size: 14px;color: #606266">是否绑定微信：</span>
          <br>
          <el-switch
            class="switcha"
            disabled
            v-model="switch1"
            active-color="#ff4949"
            inactive-color="#13ce66"
          >
          </el-switch>
          &nbsp;
          <span style="color: #ff4949" v-show="switch1">否</span><span style="color: #a2a1a1" v-show="switch1">（请退出重新登绑定微信）</span>
          <span style="color: #13ce66" v-show="!switch1">是</span>
        </el-form-item>
      </div>
          <br>
       <el-button style="margin-left: 35px"  class="btn-submit" @click="update()">确认</el-button>
        </el-form>

    </div>
    <!-- {{$url.img +imageUrl}}
    <el-image :src="$url.img +imageUrl"></el-image> -->
  </div>
</template>

<script>
import { getadmin ,updateadminuserinfo} from "../../api/userMG";
export default {
  inject: ["reload"],
  data() {
    return {
      token:localStorage.getItem('token'),
      pic:'',
      picStr:'',
      imageUrl: '',
      tableData:[],
      name:'',
      openid:'',
      switch1:true

    }
  },
  // 注册组件
  components: {

  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
      //验证上传的图片格式
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg'||'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG,png 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      //上传图片地址
        handleAvatarSuccess(file) {
          //  this.imageUrl = file.data.pic
          try {
              this.imageUrl = file.data.pic;
              this.update()
              } catch (error) {
                this.$message.error(file.error)
              // this.imageUrl = window.URL.createObjectURL(file);
              }
            // this.imageUrl =window.URL.createObjectURL();
            // console.log(this.imageUrl)
      },
      userData(){
          let params={
            token: localStorage.getItem("token"),
            id:localStorage.getItem("userId"),
          };
        getadmin(params).then(res=>{
            if (res.errno === 0) {
                this.tableData=res.data
                this.username=res.data.username
                this.imageUrl=res.data.avatar
                this.picStr=res.data.avatar
                this.openid = res.data.openid
              if (this.openid == null || this.openid == '' || this.openid == 'null'){
                this.switch1 = true
              }else{
                this.switch1 = false
              }
                } else if (res.errno === 401) {
                this.$store.dispatch("LogOut").then(() => {
                    location.reload(); // 为了重新实例化vue-router对象 避免bug
                });
                } else {
                this.$message.error(res.error);
                }
          })
      },
      update(){
        let params={
          token: localStorage.getItem("token"),
          id:localStorage.getItem("userId"),
          username:this.tableData.username,
          name:this.tableData.name,
          avatar:this.imageUrl
        }
        updateadminuserinfo(params).then(res=>{
          if (res.errno === 0) {
            if (this.picStr!=this.imageUrl) {
              this.re()
            }
            if (this.username!=this.tableData.username) {
              this.$store.dispatch('LogOut').then(()=>{
                location.reload()// 为了重新实例化vue-router对象 避免bug
              })
              this.$message({
                type:'warning',
                message:'登录名发生变化，请重新登录'
              })
            }else{
                this.$message({
                type: "success",
                message: res.data,
          });
            }
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
        })
      },
      async re() {
      this.reload();
    },
  },
  mounted() {
      this.userData()
  }
}
</script>

<style scoped>

  .in_2 >>> .el-avatar>img{
    display: inline-block;
  }
.info{
  padding:20px 20px;
  /*height: 100%;*/
  background-color: #ffffff;
}
.divider{
  margin: 16px 0;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-form-item{
    margin: 0px;
    font-size: 12px;
  }
.in>>>.el-input__inner{
  width: 394px;
  height: 32px;
  color: #999999;
  font-size: 12px;
  border: 1px solid #cccccc;
}
.in>>>.el-input__inner:hover{
  border: 1px solid #b0bceb;
}
.in>>>.el-input__inner:focus{
  border:1px solid #2b52e9;
  color: #333333;
  font-size: 12px;
}
  .switcha >>> .el-switch{
    margin-bottom: -1px;
  }
  .switcha >>> .el-switch__label{
    color: #a2a1a1;
  }
  .switcha >>> .el-switch__label.is-active{
    color: #409EFF;
  }
</style>





// WEBPACK FOOTER //
// src/views/account/role.vue